import ApplicationModel, { attr } from '../ApplicationModel';
import { type PollAttributes } from './generated/PollAttributes';
import { model } from '../modelBuilder';

interface Poll extends PollAttributes {}

@model
class Poll extends ApplicationModel {
  // Start auto-generated
  static typename: 'Poll' = 'Poll';
  get typename(): 'Poll' {
    return 'Poll';
  }

  static internalTypename: 'Polls::Poll' = 'Polls::Poll';
  get internalTypename(): 'Polls::Poll' {
    return 'Polls::Poll';
  }

  static filterType = 'PollFilters!';
  static filters = { id: '[ID!]', projectId: 'ID', query: 'String' };

  static fields = {
    commentsCount: attr({ readable: true }),
    createdAt: attr({ readable: true }),
    id: attr({ readable: true }),
    name: attr({ readable: true }),
    path: attr({ readable: true }),
    projectId: attr({ readable: true }),
    referenceNum: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    description: attr.belongsTo({ readable: true, typename: 'Note' }),
    project: attr.belongsTo({ readable: true, typename: 'Project' }),
    comments: attr.hasMany({ readable: true }),
    tasks: attr.hasMany({ readable: true }),
  };
  // End auto-generated
}

export default Poll;
